// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"38":"a80d7377","41":"30448a85","97":"4527047b","167":"67835f38","177":"62340234","389":"36a79034","659":"97387f70","734":"770901fa","867":"b7dc86f8","941":"a3072a36"}[chunkId] + ".css";
};